import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";
import {
    deletePromoterCategory,
    getPromoterCategories,
    savePromoterCategory,
    updatePromoterCategory
} from "../../helpers/promoterCategoryService";

export const FETCH_PROMOTER_CATEGORIES_BEGIN = 'FETCH_PROMOTER_CATEGORIES_BEGIN';
export const FETCH_PROMOTER_CATEGORIES_SUCCESS = 'FETCH_PROMOTER_CATEGORIES_SUCCESS';
export const FETCH_PROMOTER_CATEGORIES_ERROR = 'FETCH_PROMOTER_CATEGORIES_ERROR';

/*
 * action creators
 */

const fetchPromoterCategoriesSuccess = res => ({
    type: FETCH_PROMOTER_CATEGORIES_SUCCESS,
    payload: {
        promoterCategories: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPromoterCategoriesError = error => ({
    type: FETCH_PROMOTER_CATEGORIES_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPromoterCategories = query => dispatch => {
    dispatch({type: FETCH_PROMOTER_CATEGORIES_BEGIN});
    return getPromoterCategories(query).then(res => {
        dispatch(fetchPromoterCategoriesSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPromoterCategoriesError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const saveNewPromoterCategory = category => dispatch => {
    return savePromoterCategory(category).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const updateSinglePromoterCategory = category => dispatch => {
    return updatePromoterCategory(category).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const removePromoterCategory = categoryId => dispatch => {
    return deletePromoterCategory(categoryId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/promoter/promoterCategoryActions.js